module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_c('div', {
    staticClass: "danwei-warp"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.row.danwei))]), _vm._v(" "), _c('div', {
    staticClass: "saiqu"
  }, [_vm._v(_vm._s(_vm.row.datetitle) + " " + _vm._s(_vm.row.province) + _vm._s(_vm.row.city))]), _vm._v(" "), (_vm.row.member_list.length > 0) ? _c('div', {
    staticClass: "duiwu"
  }, [_vm._l((_vm.row.member_list), function(member, mkey) {
    return (mkey < 4) ? _c('span', {
      key: mkey
    }, [_vm._v(_vm._s(member.name) + " ")]) : _vm._e()
  }), _vm._v("\n            等" + _vm._s(_vm.row.members) + "人报名\n        ")], 2) : _c('div', {
    staticClass: "duiwu"
  }, [_vm._v("\n            暂无人员报名\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "step-warp"
  }, [_c('van-steps', {
    attrs: {
      "direction": "vertical",
      "active-color": "#00B388",
      "active": _vm.active
    }
  }, [_c('van-step', [_c('div', {
    staticClass: "step-li"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("联系人信息")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("联系人及联系方式")]), _vm._v(" "), (_vm.row.status != 2) ? _c('div', {
    staticClass: "right tiny-btn-0",
    on: {
      "click": function($event) {
        return _vm.action(1)
      }
    }
  }, [_vm._v("修改信息")]) : _vm._e()])]), _vm._v(" "), _c('van-step', [_c('div', {
    staticClass: "step-li"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("人员信息")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("人员报名管理")]), _vm._v(" "), (_vm.row.status != 2) ? _c('div', {
    staticClass: "right tiny-btn-0",
    on: {
      "click": function($event) {
        return _vm.action(2)
      }
    }
  }, [_vm._v("人员管理")]) : _vm._e()])]), _vm._v(" "), _c('van-step', [_c('div', {
    staticClass: "step-li"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("确认订单并支付")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("确认订单支付费用")]), _vm._v(" "), (_vm.row.member_list.length > 0 && _vm.row.status != 2) ? _c('div', {
    staticClass: "right tiny-btn-0",
    on: {
      "click": function($event) {
        return _vm.action(4)
      }
    }
  }, [_vm._v("支付费用")]) : _vm._e()])]), _vm._v(" "), _c('van-step', [_c('div', {
    staticClass: "step-li"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("报名成功")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("报名成功")]), _vm._v(" "), (_vm.row.member_list.length > 0 && _vm.row.status == 2) ? _c('div', {
    staticClass: "right tiny-btn-1",
    staticStyle: {
      "top": "0 !important"
    },
    on: {
      "click": function($event) {
        return _vm.action(6)
      }
    }
  }, [_vm._v("观看视频学习")]) : _vm._e(), _vm._v(" "), (_vm.row.member_list.length > 0 && _vm.row.status == 2) ? _c('div', {
    staticClass: "right tiny-btn-0",
    staticStyle: {
      "top": "auto !important",
      "bottom": "0 !important"
    },
    on: {
      "click": function($event) {
        return _vm.action(5)
      }
    }
  }, [_vm._v("开始考试")]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "title"
  }), _vm._v(" "), (_vm.row.erweiimg.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.row.erweiimg[0].url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.erweiimg.length > 0) ? _c('p', [_vm._v("扫码加工作人员好友，提交考试视频")]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e39f258","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cba/CbaApplyDetail.vue
// module id = 1210
// module chunks = 0